import * as actionTypes from './../Register_action.types';
import * as api from './../register_api_services/AttendanceRegister.api';


export const getAttentanceRequest = () => ({
  type: actionTypes.GET_SALARY_REGISTER_REQUEST,
});

export const getAttentanceSuccess = (clients) => ({
  type: actionTypes.GET_SALARY_REGISTER_SUCCESS,
  payload: clients,
});

export const getAttentanceFailure = (error) => ({
  type: actionTypes.GET_SALARY_REGISTER_FAILURE,
  payload: error,
});


export const regenerateAttentanceRequest = () => ({
  type: actionTypes.REGENERATE_ATTENDANCE_REGISTER_REQUEST,
});

export const regenerateAttentanceSuccess = (clients) => ({
  type: actionTypes.REGENERATE_ATTENDANCE_REGISTER_SUCCESS,
  payload: clients,
});

export const regenerateAttentanceFailure = (error) => ({
  type: actionTypes.REGENERATE_ATTENDANCE_REGISTER_FAILURE,
  payload: error,
});

export const deleteSingleAttendanceRequest = (id) => ({
  type: actionTypes.DELETE_SINGLE_ATTENDANCE_REQUEST,
  payload: id,
});

export const deleteSingleAttendanceSuccess = (message) => ({
  type: actionTypes.DELETE_SINGLE_ATTENDANCE_SUCCESS,
  payload: message,
});

export const deleteSingleAttendanceFailure = (error) => ({
  type: actionTypes.DELETE_SINGLE_ATTENDANCE_FAILURE,
  payload: error,
});


export const multiDeleteAttendanceRequest = (ids) => ({
  type: actionTypes.MULTIPLE_DELETE_ATTENDANCE_REQUEST,
  payload: ids,
});

export const multiDeleteAttendanceSuccess = (message) => ({
  type: actionTypes.MULTIPLE_DELETE_ATTENDANCE_SUCCESS,
  payload: message,
});

export const multiDeleteAttendanceFailure = (error) => ({
  type: actionTypes.MULTIPLE_DELETE_ATTENDANCE_FAILURE,
  payload: error,
});



export const getAttendanceRegister = (current_month) => {
  return async (dispatch) => {
    dispatch(getAttentanceRequest());
    try {
      const response = await api.fetchAttendanceRegister(current_month);
      dispatch(getAttentanceSuccess(response));
      return { success: true, data: response };
    } catch (error) {
      dispatch(getAttentanceFailure(error));
      return { success: false, error: error };
    }
  };
};

export const regenerateAttendance = (current_month) => {
  return async (dispatch) => {
    dispatch(regenerateAttentanceRequest());
    try {
      const response = await api.regenerateAttendanceRegister(current_month);
      dispatch(regenerateAttentanceSuccess(response));
      return { success: true, data: response };
    } catch (error) {
      dispatch(regenerateAttentanceFailure(error));
      return { success: false, error: error };
    }
  };
};


export const getGenerateAttentanceRequest = () => ({
  type: actionTypes.GET_SALARY_REGISTER_REQUEST,
});

export const getGeneratedAttentanceSuccess = (clients) => ({
  type: actionTypes.GET_SALARY_REGISTER_SUCCESS,
  payload: clients,
});

export const getGeneratedAttentanceFailure = (error) => ({
  type: actionTypes.GET_SALARY_REGISTER_FAILURE,
  payload: error,
});

export const fetchgenerateAttendanceRegister = (current_month) => {
  return async (dispatch) => {
    dispatch(getGenerateAttentanceRequest());
    try {
      const response = await api.fetchgenerateAttendanceRegister(current_month);
      dispatch(getGeneratedAttentanceSuccess(response));
      return { success: true, data: response };
    } catch (error) {
      dispatch(getGeneratedAttentanceFailure(error));
      return { success: false, message: error };
    }
  };
};

export const downloadAttentanceRequest = () => ({
  type: actionTypes.DOWNLOAD_ATTENDANCE_REQUEST,
});

export const downloadAttentanceSuccess = (clients) => ({
  type: actionTypes.DOWNLOAD_ATTENDANCE_SUCCESS,
  payload: clients,
});

export const downloadAttentanceFailure = (error) => ({
  type: actionTypes.DOWNLOAD_ATTENDANCE_FAILURE,
  payload: error,
});

export const downloadAttenceRegister = (data) => {
  return async (dispatch) => {
    dispatch(downloadAttentanceRequest());
    try {
      const response = await api.downloadAttendanceRegister(data);
      dispatch(downloadAttentanceSuccess(response));
      return { success: true, data: response };
    } catch (error) {
      dispatch(downloadAttentanceFailure(error));
      return { success: false, message: error };
    }
  };
};

export const downloadAllAttentanceRequest = () => ({
  type: actionTypes.DOWNLOAD_ALL_ATTENDANCE_REQUEST,
});
export const downloadAllAttentanceSuccess = (clients) => ({
  type: actionTypes.DOWNLOAD_ALL_ATTENDANCE_SUCCESS,
  payload: clients,
});

export const downloadAllAttentanceFailure = (error) => ({
  type: actionTypes.DOWNLOAD_ALL_ATTENDANCE_FAILURE,
  payload: error,
});

export const downloadAllAttenceRegister = (data) => {
  return async (dispatch) => {
    dispatch(downloadAllAttentanceRequest());
    try {
      const response = await api.downloadAllAttendanceRegister(data);
      dispatch(downloadAllAttentanceSuccess(response));
      return { success: true, data: response };
    } catch (error) {
      dispatch(downloadAllAttentanceFailure(error));
      return { success: false, message: error };
    }
  };
};



export const deleteSingleAttendanceById = (id) => {
  return async (dispatch) => {
    dispatch(deleteSingleAttendanceRequest(id));
    try {
      const response = await api.deleteSingleAttendanceRecord(id);
      dispatch(deleteSingleAttendanceSuccess(response.message));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(deleteSingleAttendanceFailure(error));
      return { success: false, message: error };
    }
  };
};


export const multiDeleteAttendanceRegister = (ids) => {
  return async (dispatch) => {
    dispatch(multiDeleteAttendanceRequest(ids));
    try {
      const response = await api.multipleDeleteAttendanceRegister(ids);
      dispatch(multiDeleteAttendanceSuccess(response));
      return { success: true, message: response };
    } catch (error) {
      dispatch(multiDeleteAttendanceFailure(error));
      return { success: false, message: error };
    }
  };
};


//   export const multiDaleteCtcMasterRequest = (ids) => ({
//     type: actionTypes.MULTI_DELETE_SALARY_REGISTER_REQUEST,
//     payload: ids,
//   });

//   export const multiDaleteCtcMasterSuccess = (message) => ({
//     type: actionTypes.MULTI_DELETE_SALARY_REGISTER_SUCCESS,
//     payload: message,
//   });

//   export const multiDaleteCtcMasterFailure = (error) => ({
//     type: actionTypes.MULTI_DELETE_SALARY_REGISTER_FAILURE,
//     payload: error,
//   });

//   export const multiDeleteCtcMasterFile = (ids) => {
//     console.log(ids);
//     return async (dispatch) => {
//       dispatch(multiDaleteCtcMasterRequest(ids));
//       try {
//         const response = await api.multiDeleteCtcMaster(ids);
//         dispatch(multiDaleteCtcMasterSuccess(response));
//         return { success: true, message: response };
//       } catch (error) {
//         dispatch(multiDaleteCtcMasterFailure(error));
//         return { success: false, message: error };
//       }
//     };
//   };

//   export const updateCtcMasterRequest = (id, clientData) => ({
//     type: actionTypes.UPDATE_SALARY_REGISTER_REQUEST,
//     payload: { id, clientData },
//   });

//   export const updateCtcMasterSuccess = (message) => ({
//     type: actionTypes.UPDATE_SALARY_REGISTER_SUCCESS,
//     payload: message,
//   });

//   export const updateCtcMasterFailure = (error) => ({
//     type: actionTypes.UPDATE_SALARY_REGISTER_FAILURE,
//     payload: error,
//   });

//   export const updateCtcMasterById = (id, salaryData) => {
//     return async (dispatch) => {
//       const user = JSON.parse(sessionStorage.getItem('user'));
//       salaryData.updated_by = user.user_name;

//       dispatch(updateCtcMasterRequest(id, salaryData));
//       try {
//         const response = await api.updateCtcMaster(id, salaryData);
//         dispatch(updateCtcMasterSuccess(response.message));
//         return { success: true, message: response.message };
//       } catch (error) {
//         dispatch(updateCtcMasterFailure(error));
//         return { success: false, message: error };
//       }
//     };
//   };
//   export const deleteCtcMasterRequest = (id) => ({
//     type: actionTypes.DELETE_SALARY_REGISTER_REQUEST,
//     payload: id,
//   });

//   export const deleteCtcMasterSuccess = (message) => ({
//     type: actionTypes.DELETE_SALARY_REGISTER_SUCCESS,
//     payload: message,
//   });

//   export const deleteCtcMasterFailure = (error) => ({
//     type: actionTypes.DELETE_SALARY_REGISTER_FAILURE,
//     payload: error,
//   });

//   export const deleteCtcMasterById = (id) => {
//     return async (dispatch) => {
//       dispatch(deleteCtcMasterRequest(id));
//       try {
//         const response = await api.deleteCtcMaster(id);
//         dispatch(deleteCtcMasterSuccess(response.message));
//         return { success: true, message: response.message };
//       } catch (error) {
//         dispatch(deleteCtcMasterFailure(error));
//         return { success: false, message: error };
//       }
//     };
//   };
